import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import API_ENDPOINTS, { CONVERT_TO_SLUG } from '../../helperFunction/Constant';
import ApiHelper from '../../helperFunction/ApiHelper';
import { Toast } from 'primereact/toast';
import Layout from '../common/Layout';
import { useForm } from 'react-hook-form';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { TabPanel, TabView } from 'primereact/tabview';
import AddCollectionCourses from './AddCollectionCourses';
import SeoCollection from './SeoCollection';

const AddCollections = () => {

    const [activeIndex, setActiveIndex] = useState(0);

    const { id } = useParams()
    const isEdit = id ? true : false
    const toast = useRef(null)
    const navigate = useNavigate()

    const [collectionData, setCollectionData] = useState([])

    useEffect(() => {
        isEdit && getCollectionData()
    }, [id])

    const schema = yup.object({
        collectionName: yup.string().required("Name is required"),
        collectionDescription: yup.string().required("Description is required"),
        collectionImage: yup.mixed().optional(),
        collectionSlug: yup.string().notRequired(), 
        metaTitle: yup.string().notRequired(), 
        metaDescription: yup.string().notRequired(), 
        metaKeywords: yup.string().notRequired(),  
        isActive: yup.boolean(),
    });

    const { register, handleSubmit, reset, watch, resetField, formState: { errors }, } = useForm({ resolver: yupResolver(schema), });
    
    const previewImage = watch('collectionImage')

    const resetValue = () => {
        reset({
            collectionName: '',
            collectionDescription: '',
            collectionImage: null,
            collectionSlug: '',
            metaTitle: '',
            metaDescription: '',
            metaKeywords: '',
            isActive: '',
        })
    }

    const getCollectionData = (collectionId) => {
        ApiHelper.get(`${API_ENDPOINTS.COLLECTION}/${collectionId ? collectionId : id}`).then((res) => {
            if (res.status === 200) {
                setCollectionData(res.data.data)
                reset({
                    collectionName: res.data.data.collectionName,
                    collectionDescription: res.data.data.collectionDescription,
                    collectionSlug: res.data.data.collectionSlug,
                    metaTitle: res.data.data.metaTitle,
                    metaDescription: res.data.data.metaDescription,
                    metaKeywords: res.data.data.metaKeywords,
                    isActive: res.data.data.isActive,
                })
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const onSubmit = (data) => {
        const formData = new FormData()
        if (!data.collectionSlug) {
            data.collectionSlug = CONVERT_TO_SLUG(data?.collectionName)
        } else {
            data.collectionSlug = CONVERT_TO_SLUG(data?.collectionSlug)
        }

        if (data?.metaTitle) formData.append('metaTitle', data?.metaTitle);
        if (data?.metaDescription) formData.append('metaDescription', data?.metaDescription);
        if (data?.metaKeywords) formData.append('metaKeywords', data?.metaKeywords);

        formData.append('collectionName', data?.collectionName);
        formData.append('collectionDescription', data?.collectionDescription);
        formData.append('collectionSlug', data?.collectionSlug);
        if (data.collectionImage) {
            formData.append('collectionImage', data.collectionImage[0]);
        } 
        formData.append('isActive', data.isActive);
        if (isEdit) {
            update(formData)
        } else {
            add(formData)
        }
    };
    const add = (data) => {
        ApiHelper.post(`${API_ENDPOINTS.COLLECTION}/`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setTimeout(() => {
                    navigate(`/collections/edit/${res.data?.collectionId}`)
                }, 1000)
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };

    const update = (data) => {
        ApiHelper.put(`${API_ENDPOINTS.COLLECTION}/${id}`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setTimeout(() => {
                    navigate('/collections')
                }, 900)
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };

    const confirmDeleteDailog = () => {
        confirmDialog({
            message: 'Do you want to delete this record?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            defaultFocus: null,
            acceptClassName: 'p-button-danger',
            accept: () => deleteImage(),
        });
    };

    const deleteImage = () => {
        ApiHelper.post(`${API_ENDPOINTS.COLLECTION}/delete-image/${id}`).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 });
                getCollectionData()
            }
        }).catch((err) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: err.response?.data?.message, life: 3000 });
        });
    };

    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />
            <Layout>
                <div class="content-wrapper">
                    <div class="container-xxl flex-grow-1 container-p-y">
                        <div class="d-flex justify-content-between align-items-center py-3">
                            <h4 class="fw-bold py-3 mb-2">
                                <span class="d-flex text-muted fw-light"> 
                                    <p class="breadcrumb-item pageHeader active me-2 mb-0" aria-current="page" onClick={() => navigate('/collections')}> Collections </p> / <b className='mx-2'> {isEdit ? 'Edit' : "Add"} </b>
                                </span>
                            </h4>
                            <Link to="/collections" class="btn btn-secondary">⬅ Go Back</Link>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card mb-4">
                                    <div class="card-body">
                                        <form onSubmit={handleSubmit(onSubmit)}>
                                            <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                                                <TabPanel header='Basic Information'>
                                                    <div class="row mb-3">
                                                        <div class="col-md-3 mb-3">
                                                            <label class="form-label">Name</label>
                                                            <input type="text" name="collectionName" class="form-control" {...register("collectionName")} />
                                                            <small className="text-danger">{errors.collectionName?.message}</small>
                                                        </div>
                                                        <div class="col-md-3 mb-3">
                                                            <label class="form-label">Description</label>
                                                            <textarea type="text" name="collectionDescription" class="form-control" {...register("collectionDescription")} />
                                                            <small className="text-danger">{errors.collectionDescription?.message}</small>
                                                        </div>
                                                        {collectionData?.collectionImage ? (
                                                            <div class="col-md-3 mb-3">
                                                                <label class="form-label">Collection Image</label>
                                                                <br />
                                                                <div>
                                                                    <div class="d-inline-block ">
                                                                        <div class="position-relative " style={{ width: "fit-content;" }}>
                                                                            <a target="_blank">
                                                                                <img src={`${process.env.REACT_APP_BASE_URL}/${collectionData?.collectionImage}`} class="img-thumbnail" />
                                                                            </a>
                                                                            <button type="button" class="btn btn-danger btn-sm position-absolute top-0 end-0" onClick={() => confirmDeleteDailog()}> &times; </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div class="col-md-3">
                                                                <label class="form-label">Upload Collection Image</label>
                                                                <br />
                                                                <div>
                                                                    <input type="file" accept=".jpeg, .jpg, .png, .webp" name="collectionImage" {...register("collectionImage")} class="form-control fileMultiInput" />
                                                                </div>
                                                                {previewImage?.[0] && (
                                                                        <div class="mt-3 mb-2">
                                                                            <div class="d-inline-block ">
                                                                                <div class="position-relative " style={{ width: "fit-content;" }}>
                                                                                    <a target="_blank">
                                                                                        <img src={URL.createObjectURL(previewImage[0])} id="existingImagePhoto" class="img-thumbnail" />
                                                                                    </a>
                                                                                    <button type="button" class="btn btn-danger btn-sm position-absolute top-0 end-0" onClick={() => resetField('collectionImage')}> &times; </button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                }
                                                            </div>
                                                        )}
                                                        <div class="col-md-3 mt-2">
                                                            <label class="form-label">Status</label>
                                                            <div class="form-check form-switch mb-2">
                                                                <input class="form-check-input mt-2" name="isActive" type="checkbox" id="flexSwitchCheckDefault" {...register("isActive")} />
                                                                <small className="text-danger">{errors.isActive?.message}</small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </TabPanel>
                                                <TabPanel disabled={!isEdit} header='Courses'>
                                                    <AddCollectionCourses/>
                                                </TabPanel>
                                                <TabPanel disabled={!isEdit} header='SEO Setting'>
                                                    <SeoCollection register={register} />
                                                </TabPanel>
                                            </TabView>
                                            {(activeIndex === 0 || activeIndex === 2) && (
                                                <div class="mt-4">
                                                    <button type="submit" class="btn btn-primary me-3">Save</button>
                                                    <button type="button" onClick={() => resetValue()} class="btn btn-secondary reset-btn">Reset</button>
                                                </div>
                                            )}
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default AddCollections
